import {onClick, closeAllNavbarDropdowns} from '../components/NavbarSpecialElements/NavbarHelper';

let callCounter = 0;

function onReadyHandler() {
	// navbar selectors
	const NAVBAR_SELECTOR_TOGGLE = '.js-dropdown-toggle';

	const attachClickEvents = function() {
		document.querySelectorAll(NAVBAR_SELECTOR_TOGGLE).forEach(function(el) {
			if (el.id !== 'notificationCount' && el.id !== 'messageCount' && el.id !== 'favoriteCount') {
				el.replaceWith(el.cloneNode(true)); // remove all click listeners
			}
		});
		document.querySelectorAll(NAVBAR_SELECTOR_TOGGLE).forEach(function(el) {
			if (el.id !== 'notificationCount' && el.id !== 'messageCount' && el.id !== 'favoriteCount') {
				el.addEventListener('click', onClick);
			}
		});
	};


	attachClickEvents();

	// hide the dropdown on mouse outside click
	window.addEventListener('click', function(event) {
		if (!event.target.closest(NAVBAR_SELECTOR_TOGGLE)) {
			closeAllNavbarDropdowns();
		}
	});
}

function run() {
	callCounter++;
	// This shit get's called twice.... Only apply stuff at 2. call
	if (callCounter === 2) {
		if (document.readyState !== 'loading') {
			onReadyHandler();
		} else {
			window.addEventListener('DOMContentLoaded', onReadyHandler);
		}
		callCounter = 0;
	}
}

export {run};
